import React from 'react';
import {
  Box,
  Typography,
  Grid,
  alpha,
} from '@mui/material';
import {
  Router as RouterIcon,
} from '@mui/icons-material';

import WebSocketInfo from './WebSocketInfo';
import ApiKeyManagement from './ApiKeyManagement';

/**
 * Componente principal para configuração do PrinterBridge
 * Agrupa as informações de WebSocket e gerenciamento de API Keys
 */
const PrinterBridgeConfig = ({ 
  customTheme,
  onAlert
}) => {
  return (
    <Box 
      sx={{ 
        border: '1px solid',
        borderColor: alpha(customTheme.palette.divider, 0.1),
        borderRadius: 3,
        p: 3,
        bgcolor: 'background.paper'
      }}
    >
      {/* Cabeçalho da seção */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        mb: 4,
        color: customTheme.palette.primary.main
      }}>
        <RouterIcon sx={{ mr: 1 }} />
        <Typography variant="h6" fontWeight={600}>
          Configurações do Printer Bridge
        </Typography>
      </Box>

      {/* Descrição da funcionalidade */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          O <strong>Printer Bridge</strong> permite impressão remota de senhas em impressoras locais 
          através de conexão WebSocket segura. Configure as API Keys e monitore as conexões ativas.
        </Typography>
        
        <Typography variant="body2" color="text.secondary">
          <strong>Como funciona:</strong> O sistema envia comandos de impressão via WebSocket para 
          o aplicativo Printer Bridge instalado no computador local, que então executa a impressão 
          na impressora configurada.
        </Typography>
      </Box>

      {/* Grid com os componentes */}
      <Grid container spacing={4}>
        {/* Informações de Conexão WebSocket */}
        <Grid item xs={12} lg={6}>
          <WebSocketInfo 
            customTheme={customTheme}
            onAlert={onAlert}
          />
        </Grid>
        
        {/* Gerenciamento de API Keys */}
        <Grid item xs={12} lg={6}>
          <ApiKeyManagement 
            customTheme={customTheme}
            onAlert={onAlert}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PrinterBridgeConfig; 